import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=7fa4569a&"
import script from "./ActivityDetails.vue?vue&type=script&lang=ts&"
export * from "./ActivityDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports